module.exports = __webpack_public_path__ + "static/media/icon-back.44787f61.svg";